import {Injectable} from '@angular/core';
import {RestService} from "./rest.service";

@Injectable({
  providedIn: 'root'
})
export class CentroCostoService extends RestService {
  endpoint(): string {
    return "nCentroCostos";
  }
  param1(): string {
    return "nombre_ceco";
  }

  param2(): string {
    return "id_planta";
  }

  param3(): string {
    return "";
  }
}


